<template>
  <div :class="authPages">
    <router-view></router-view>
    <app-update-modal ref="app-update"></app-update-modal>
    <fub-sidebar></fub-sidebar>
    <help-sidebar></help-sidebar>
  </div>
</template>

<script>
import axios from 'axios';
import AppUpdateModal from '@/views/Components/Modals/AppUpdateModal';
import FubSidebar from '@/views/Layout/FubSidebar';
import HelpSidebar from '@/views/Components/HelpSidebar'

export default {
  components: {
    AppUpdateModal,
    FubSidebar,
    HelpSidebar
  },
  data() {
    return {
      events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
      logoutTimer: null
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters['isAuthenticated'];
    },
    pulse() {
      return this.$store.getters['profile/user'].pulse;
    },
    userEmail() {
      return this.$store.getters['profile/user'].email;
    },
    authPages() {
      const auth = ['Login', 'Register', 'Pulse Register', 'Enterprise Register', 'ClarityNOW Coaching Register', 'Unsubscribe', 'Demo', 'Expanded Leaderboard', "Observatory Expanded Leaderboard"];

      if (auth.includes(this.$route.name)) {
        return 'auth';
      } else if (this.isAuthenticated && this.pulse) {
        return 'pulse';
      } else if (this.$route.name == 'James Shaw Elevate') {
        return 'shaw';
      } else {
        return '';
      }
    }
  },
  methods: {
    async checkAuth() {
      if(this.isAuthenticated) {
        axios.get(process.env.VUE_APP_API_BASE_URL + '/user')
        .then(response => {
          this.$store.dispatch("profile/user");
        })
        .catch(error => {
          this.logout();
        });
      }
    },
    async logout() {
      if(this.isAuthenticated) {
        this.$store.dispatch("logout", {email: this.userEmail});
      }
    },
    resetTimer() {
      clearTimeout(this.logoutTimer);
      this.setTimers();
    },
    setTimers() {
      this.logoutTimer = setTimeout(this.logout, 60 * 60 * 1000);
    },
    checkUpdate() {
      if (window.localStorage.getItem('version-update-needed')) {
        this.$bvModal.show('app-update-modal');
      }
    }
  },
  mounted() {
    this.events.forEach(function (event) {
      window.addEventListener(event, this.resetTimer);
    }, this);

    this.setTimers();
    this.checkUpdate();
  },
  created() {
    this.checkAuth();
  },
  watch: {
    '$route'(to, from) {
      if (to.meta.observatory) {
        const user = this.$store.getters["profile/user"];
        this.$store.dispatch('observed/observed', {user: user.slug, observed: this.$route.params.user});
      }
    }
  }
}
</script>
<style lang="scss">
body {
  overflow-x: hidden;
  .navbar-top.border-bottom.navbar-light {
    background: transparent !important;
    position: absolute;
    z-index: 1000;
    width: 100%;
    border-bottom: none !important;
  }
  .header.bg-danger {
    padding-top: 70px;
    background-image: url("/img/brand/cn-bars.png"), linear-gradient(87deg, #3D5F71, #aaaaaa 300%) !important;
    background-position: 99% 20%;
    background-repeat: no-repeat;
  }
  .pulse .header.bg-danger {
    padding-top: 70px;
    background-image: linear-gradient(87deg, #262262 40%, #DDB143 100%) !important;
    background-position: 99% 20%;
    background-repeat: no-repeat;
  }
  .auth {
    background-image: url('/img/signin-background.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, .2);
  }
  .shaw {
    background-image: url('/img/james-shaw/blue-sky.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, .2);
  }
}
</style>